import React from "react";
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from "react-toastify";

import { renderError } from "../../helpers/errors";
import api from "../../services/api";

import AuthTemplate from "../../templates/Auth";

import Input from "../../components/Input";
import Button from "../../components/Button";

export const PasswordRecovery = () => {
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const emailFromLogin = location.state?.email || '';
    const [email, setEmail] = useState(emailFromLogin);

    const [recaptchaToken, setRecaptchaToken] = useState('');

    useEffect(() => {
        if (emailFromLogin) {
            setEmail(emailFromLogin);
        }
    }, [emailFromLogin]);

    const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(recaptchaKey, { action: 'login' })
                    .then(token => {
                        setRecaptchaToken(token);
                        setLoading(false);
                    })
                    .catch(error => {
                        console.error('Erro ao gerar token do reCAPTCHA:', error);
                        toast.error('Erro ao carregar o reCAPTCHA');
                        setLoading(false);
                    });
            });
        };

        return () => {
            document.body.removeChild(script);
        };
    }, [recaptchaKey]);

    const recoveryPassword = () => {
        if (!recaptchaToken) {
            toast.error("Erro ao carregar o reCAPTCHA.");
            return;
        }

        setLoading(true);

        api.post(`/recovery-password`, { 
            email, 
            recaptcha_token: recaptchaToken
        }).then(res => {
            window.location.href = "/password-reset";
        }).catch(error => {
            renderError(error);

            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(recaptchaKey, { action: 'login' })
                    .then(token => setRecaptchaToken(token))
                    .catch(error => {
                        console.error('Erro ao gerar token do reCAPTCHA:', error);
                        toast.error('Erro ao carregar o reCAPTCHA');
                    });
            });
        }).finally(() => setLoading(false));
    };

    return (
        <AuthTemplate>
            <h3 className="mb-15">Recuperação de senha</h3>
            <span className="mb-30">Informe seu e-mail e enviaremos um e-mail para redefinição da sua senha.</span>
            <Input type={`email`} label={`E-mail`} value={email}  change={setEmail} />
            <Button type={`primary`} text={`Enviar e-mail`} full={true} svg={`arrow-right-white`} loading={loading} action={recoveryPassword} />
            <span>
                Não precisa mais?
                <Link to="/login" className="mt-4 text-sm text-blue-600">
                    Voltar ao login
                </Link>
            </span>
        </AuthTemplate>
    );
}

export default PasswordRecovery;